import React from 'react'
import { checkNavigator } from './firebaseInit';

const Notification = () => {
    checkNavigator();
   
    return (
        <></>
    )
}
export default Notification